export default __webpack_public_path__ + "static/media/AS.0beacefa.svg";